import React from 'react';
import { useFormState } from '../useFormState';
import NewActivityAmenitiesForm from '../../Owner/Activity/NewActivityAmenitiesForm';
import NewPropertyAmenitiesForm from '../../Owner/Property/NewPropertyAmenitiesForm';
import NewBoatAmenitiesForm from '../../Owner/Boat/NewBoatAmenitiesForm';
import NewCommercialAmenitiesForm from '../../Owner/Commercial/NewCommercialAmenitiesForm';
import NewVehicleAmenitiesForm from '../../Owner/Vehicle/NewVehicleAmenitiesForm';
import SpaceConfiguration from '../../Spaces/SpaceConfiguration';
import { ExperienceType } from '../../../../enums/experience';
import { Stack } from '@mui/material';

const ExperienceAmenities = () => {
    const { experience } = useFormState();

    const AmenitiesForm = () => {
        switch (experience.type) {
            case ExperienceType.Property:
                return <NewPropertyAmenitiesForm />;
            case ExperienceType.Activity:
                return <NewActivityAmenitiesForm />;
            case ExperienceType.Boat:
                return <NewBoatAmenitiesForm />;
            case ExperienceType.Commercial:
                return <NewCommercialAmenitiesForm />;
            case ExperienceType.Vehicle:
                return <NewVehicleAmenitiesForm />;
        }
    };

    return (
        <Stack spacing={4}>
            <AmenitiesForm />
            {(experience.type === ExperienceType.Property ||
                experience.type === ExperienceType.Boat ||
                experience.type === ExperienceType.Commercial) && (
                <SpaceConfiguration />
            )}
        </Stack>
    );
};

export default ExperienceAmenities;
